// extracted by mini-css-extract-plugin
export var bottomLeft = "Map-module--bottomLeft--JvfKA";
export var bottomRight = "Map-module--bottomRight--FicrA";
export var mapContainer = "Map-module--mapContainer--eBcc5";
export var mapLabel = "Map-module--mapLabel--3pEXE";
export var page404Title = "Map-module--page404-title--MMAar";
export var topLeft = "Map-module--topLeft--3+uJe";
export var topRight = "Map-module--topRight--wpL1j";